<template>
    <modal :title="title">
        <div v-if="id === 'mTAN-Handynummer'">
            Wenn sich deine Handynummer geändert hat, fülle bitte das
            <a
                href="#"
                @click.prevent="
                    Browser.open({
                        url:
                            'https://www.wuestenrot.at/de/eservices-formulare/registrierung.html',
                    })
                "
                >Anmeldeformular</a
            >
            erneut aus und sende es unterschrieben an uns retour. Eine
            telefonische Änderung der Handynummer ist nicht möglich. Nach der
            Änderung erhältst du ein Bestätigungsschreiben in deine Postbox.
        </div>
        <div v-else-if="id === 'Passwort'">
            Eine Änderung deines Passwortes ist aktuell nur über unsere
            <a
                href="#"
                @click.prevent="
                    Browser.open({
                        url:
                            'https://www.wuestenrot.at/de/eservices-startseite.showLoginArea.html',
                    })
                "
                >eServices</a
            >
            unter Mein Profil möglich.
        </div>
        <div v-else-if="id === 'Bankdaten'">
            Du hast aktuell die Zahlungsvariante Erlagschein ausgewählt. Du
            möchtest einen Abbuchungsauftrag einrichten? Wende dich dazu gerne
            an deinen
            <a @click="goToCoach()">Finanzberater</a>
            oder an unser <a href="tel:+4357070777">Kundenservice</a>.
        </div>
        <div v-else-if="id === 'QR-Code'">
            <a href="#" @click.prevent="Browser.open({ url: qrCode })">{{
                qrCode
            }}</a>
        </div>
        <div v-else-if="id === 'Biketrax-AGB'">
            Aktion gültig für die ersten 200 Kunden, die ab dem 15.06.2020 eine
            neue Eigenheim-/Haushaltsversicherung mit dem Baustein
            „<b>MOBILITÄTS</b>-SCHUTZ PLUS“ abschließen. Am besten nimmst du
            hier mit deinem <a @click="goToCoach()">Berater</a> kontakt auf.
        </div>
        <div v-else-if="id === 'Biketrax-Infos'">
            Mit dem <b>MOBILITÄTS</b>-SCHUTZ PLUS sind deine Fahrräder/E-Bikes
            oder E-Scooter ab sofort gegen Diebstahl versichert und das auch
            außerhalb deiner eigenen Kellerräume. Egal, ob du dich mit deinem
            fahrbaren Untersatz in Österreich oder in den angrenzenden
            Nachbarstaaten bewegst, profitierst du vom vollen Schutz: Diebstahl
            und Raub bis 7.000 EUR + Haftpflichtschutz bis 5 Mio. EUR. Für mehr
            Infos wende dich bitte an deinen
            <a @click="goToCoach()">Berater</a>.
        </div>
        <div v-else-if="id === 'Biketrax-Datenschutz'">
            <base-checkbox
                v-model="biketraxDatenschutz"
                id="biketrax-datenschutz"
                lines="none"
                label="Ich akzeptiere die <a href='https://modrive.at/datenschutz-impressum/' target='_blank' @click.stop>Datenschutzbestimmungen</a> der PowUnity GmbH und die Registrierung eines neuen Users."
            ></base-checkbox>
        </div>
        <div v-else-if="id === 'Unwetter-Teilnahme'">
            <h3>
                Teilnahmebedingungen für Wüstenrot Unwetterwarnung
            </h3>
            <br />
            1. Die angebotene Wüstenrot Unwetterwarnung wird von der Wüstenrot
            Versicherung AG, Alpenstraße 61, 5020 Salzburg, Österreich, in
            Kooperation mit der Ubimet GmbH, Donau-City-Straße 11, 1220 Wien,
            Österreich, zur Nutzung angeboten. Die hier und in der Beschreibung
            des Services dargestellten Leistungen können erst nach Registrierung
            auf der Website der Wüstenrot Versicherung AG bezogen werden. Das
            Angebot der Wüstenrot Unwetterwarnung ist kostenfrei zu verwenden,
            gilt nur für Kunden der Wüstenrot Versicherung AG mit aufrechter
            KFZ-Haftpflichtversicherung, aufrechter Haus & Heim Versicherung
            und/oder aufrechtem Profipaket für Landwirte. Nicht-Kunden steht die
            kostenlose Unwetterwarnung per SMS und/oder E-Mail nicht zur
            Verfügung. Die Wüstenrot SMS-Unwetterwarnung kann nur von Kunden,
            die einen Handyvertrag mit einem österreichischen Mobilfunkanbieter
            haben, genutzt werden.<br />
            <br />
            2. Je nach Tarif, Aufenthaltsort (Ausland) und Mobilfunkanbieter
            können Gebühren für die Nutzung Ihres Mobiltelefons für den Zugriff
            auf das Internet und für den Empfang von SMS eingehoben werden.
            Derartige Gebühren sind jedenfalls von Ihnen selbst zu tragen.<br />
            <br />
            3. Die Datenkommunikation über Internet und Mobilfunknetze kann nach
            derzeitigem Stand der Technik nicht fehlerfrei und/oder jederzeit
            verfügbar garantiert werden. Die Übermittlung der SMS ist auf
            technische Infrastruktur angewiesen, die teilweise nicht von der
            Wüstenrot Versicherung AG beeinflusst werden kann. Ubimet GmbH und
            Wüstenrot Versicherung AG haften daher nicht für die ständige und
            ununterbrochene Verfügbarkeit dieses Service.<br />
            <br />
            4. Die bereit gestellten meteorologischen Informationen werden mit
            der üblichen wissenschaftlichen Sorgfalt gewonnen, unter Beachtung
            der anerkannten Regeln von Wissenschaft und Technik. Dennoch können
            Fehler nicht gänzlich ausgeschlossen werden, weshalb Ubimet GmbH und
            Wüstenrot Versicherung AG keine Gewähr für die Richtigkeit der zur
            Verfügung gestellten Informationen leisten.<br />
            <br />
            5. Ubimet GmbH und Wüstenrot Versicherung AG haften nur für grobe
            Fahrlässigkeit und Vorsatz. Insbesondere übernehmen Ubimet GmbH und
            Wüstenrot Versicherung AG keine Haftung für Schäden und/oder
            Störungen, die aufgrund höherer Gewalt eintreten. Des Weiteren
            übernehmen Ubimet GmbH und Wüstenrot Versicherung AG keine Haftung
            für allfällige aus den zur Verfügung gestellten Informationen durch
            Sie gezogenen Schlüssen und allfällig daraus resultierende
            Schäden.<br />
            <br />
            6. Die automatisiert zur Verfügung gestellten Wetterinformationen
            dienen lediglich allgemeinen Informationszwecken und dürfen nicht
            alleine als verlässliche Grundlage für stark wettersensitive Zwecke
            genutzt werden, insbesondere nicht, wenn falsche, ungenaue,
            zeitverzögerte oder unvollständige meteorologische Information zu
            Todesfällen, Körperverletzungen oder Sach- und Umweltschäden führen
            können. Ubimet GmbH und Wüstenrot Versicherung AG übernehmen keine
            Gewähr für die Verfügbarkeit, Genauigkeit, Vollständigkeit,
            Zuverlässigkeit oder Aktualität der über dieses Service zur
            Verfügung gestellten meteorologischen Information.<br />
            <br />
            7. Die Nutzung der zur Verfügung gestellten Informationen ist
            örtlich auf das österreichische Staatsgebiet und sachlich auf den
            privaten Gebrauch beschränkt. Eine darüber hinausgehende Nutzung ist
            ohne schriftliche Zustimmung von Ubimet GmbH und Wüstenrot
            Versicherung AG nicht erlaubt. Es ist keinesfalls gestattet,
            Informationen aus diesem Service kommerziell zu nutzen, zu
            verkaufen, zu verleasen, weiter zu leiten oder in eigene Produkte zu
            integrieren.<br />
            <br />
            8. Das Urheberrecht und alle Werknutzungsrechte (Copyright etc.) an
            dem Unwetterservice und an den von Ubimet GmbH und Wüstenrot
            Versicherung AG zur Verfügung gestellten Informationen, insbesondere
            an meteorologischen Prognosedaten, Grafiken, Visualisierungen etc.
            verbleiben bei Ubimet GmbH und Wüstenrot Versicherung AG.<br />
            <br />
            9. Die meteorologische Information wird mit der gebotenen Sorgfalt
            auf dem Stand von Wissenschaft und Technik erstellt. Es liegt in der
            Natur der Wettervorhersage, dass diese nicht zu 100 Prozent richtig
            sein können. Ubimet GmbH und Wüstenrot Versicherung AG übernehmen
            daher keine Haftung für die Richtigkeit der zur Verfügung gestellten
            Information.<br />
            <br />
            10. Ubimet GmbH und Wüstenrot Versicherung AG behalten sich das
            Recht vor, Leistungen zu erweitern, zu ändern und Verbesserungen
            vorzunehmen und werden betroffene Nutzer über etwaige Änderungen
            zeitgerecht informieren. Soweit es sich bei den gegenständlichen
            Diensten und Leistungen um kostenlose Services handelt, können diese
            jederzeit und ohne Vorankündigung eingestellt werden. Ein Recht auf
            Minderung, Wandlung oder Erstattung von Ubimet GmbH oder Wüstenrot
            Versicherung AG entgeltlich bezogener Dienste und Leistungen ergibt
            sich daraus nicht. Für den Fall der Entgeltlichkeit von Leistungen
            werden Änderungen mit angemessener Vorlaufzeit bekannt gegeben und
            dem Nutzer die Möglichkeit eingeräumt, das Service fristgerecht zu
            kündigen. Änderungen, die ausschließlich durch technischen
            Fortschritt, gesetzliche Änderungen bedingt sind, berechtigen den
            Nutzer jedoch nicht zu einer Kündigung.<br />
            <br />
            11. Erfüllungsort für die angebotenen Leistungen ist Salzburg. Es
            gilt ausschließlich österreichisches Recht unter gleichzeitigem
            Ausschluss seiner Verweisungsnormen. Für jegliche aus der Nutzung
            der hier angebotenen Services ist örtlich ausschließlich das jeweils
            sachlich zuständige Gericht für Salzburg zuständig. Sollten einzelne
            Teile dieser Nutzungsbedingungen nichtig, unwirksam oder anfechtbar
            sein oder werden, oder sollten diese unvollständig sein, so bleiben
            die übrigen Bestimmungen davon unberührt und sind so auszulegen bzw.
            zu ergänzen, dass der von Ubimet GmbH und Wüstenrot Versicherung AG
            beabsichtigte Zweck in rechtlich zulässiger Weise möglichst genau
            erreicht wird.<br />
            <br />
            12. Zur Erfüllung des Vertrags werden gemäß Art 6 Abs 1 lit b DSGVO
            die zur Erbringung des Unwetterservices notwendigen
            personenbezogenen Daten des Versicherungsnehmers (Handy-Nummer bzw.
            E-Mailadresse, Postleitzahl) von Wüstenrot automationsunterstützt
            verarbeitet und zu diesem Zweck an UBIMET GmbH, Donau-City-Straße
            11, A 1220 Wien, E-Mail Adresse:
            <a href="mailto:info@ubimet.com">info@ubimet.com</a> zum Zwecke der
            Vertragsabwicklung übermittelt.
        </div>
        <template v-slot:footer>
            <ion-button expand="block" @click="clickButton()">{{
                buttonText
            }}</ion-button>
        </template>
    </modal>
</template>

<script>
import Modal from "./Modal";
import { Plugins } from "@capacitor/core";
import BaseCheckbox from "./BaseCheckbox";

export default {
    components: {
        Modal,
        BaseCheckbox,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
        motive: {
            type: String,
            required: false,
            default: "",
        },
        contractId: {
            type: String,
            required: false,
            default: "",
        },
        qrCode: {
            type: String,
            required: false,
            default: "",
        },
        buttonText: {
            type: String,
            required: false,
            default: "Verstanden",
        },
        title: {
            type: String,
            required: false,
            default: "Hinweis",
        },
    },
    data() {
        return {
            Browser: Plugins.Browser,
            biketraxDatenschutz: false,
        };
    },
    methods: {
        goToCoach() {
            this.$ionic.modalController.dismiss();
            this.$router.push({
                name: "motive-beraterdetails",
                params: {
                    motive: this.motive,
                    contractId: this.contractId,
                },
            });
        },
        clickButton() {
            if (this.id === "Biketrax-Datenschutz") {
                this.$store
                    .dispatch("biketrax/activateEbikeTracker", {
                        vertragsnummer: this.contractId,
                        pushtoken: this.$store.state.pushToken,
                        datenschutz: this.biketraxDatenschutz,
                    })
                    .then(() => {
                        this.$ionic.modalController.dismiss();
                    });
            } else {
                this.$ionic.modalController.dismiss();
            }
        },
    },
};
</script>

<style></style>
